import { hooks } from '@/store.js';

import { memo, useEffect, useRef, useState } from 'react';
import isEqual from 'react-fast-compare';

import useConfirm from '@/hooks/useConfirm/index.jsx';
import useUpload from '@/hooks/useUpload.js';
import { useEventListener } from 'ahooks';

const UploadArticle = memo(
  ({
    defaultValue,
    onDelete,
    onSave,
    className,
    title,
    onCancel,
  }: {
    defaultValue?: string;
    onDelete?: () => void;
    onSave?: (payload: { url: string }) => void;
    className?: string;
    onCancel?: () => void;
    title?: string;
  }) => {
    const [previewImage, setPreviewImage] = useState<string | null>(
      defaultValue && defaultValue !== 'CHOOSE' ? defaultValue : null
    );
    const inputRef = useRef<HTMLInputElement | null>(null);

    const { handleFileChange, uploadProgress, reset } = useUpload({
      async onSuccess(payload) {
        onSave?.(payload);
      },
      onFileLoad(reader) {
        setPreviewImage(reader.target?.result as string);
      },
      keyPrefix: 'upload_images',
    });

    const { showModal } = useConfirm({
      isSubmitting: false,
      onSubmit: async () => {
        await onDelete?.();

        reset();
        setPreviewImage(null);

        if (inputRef.current) {
          inputRef.current.value = '';
        }
      },
    });

    useEffect(() => {
      if (defaultValue === 'CHOOSE') {
        inputRef.current?.click();
      }
    }, [defaultValue]);

    useEventListener('cancel', () => onCancel?.(), { target: inputRef });

    return (
      <article
        className={` relative border bg-center  border-gray-300  bg-cover text-xs rounded-xl flex flex-col items-center justify-center text-gray-400/80 ${
          previewImage ? '' : ' border-dashed '
        } ${className}`}
        style={{
          backgroundImage: `url(${previewImage})`,
          width: 13 * 4,
          height: 13 * 4,
        }}
      >
        {!previewImage && (
          <>
            <i className='ic-round md-add text-xl leading-none ' />
            {title}
          </>
        )}

        <input
          className=' absolute left-0 top-0 w-full h-full opacity-0'
          type='file'
          onChange={handleFileChange}
          accept='image/*'
          ref={inputRef}
        />

        {uploadProgress > 0 && (
          <span className=' absolute w-full h-full top-0 left-0 bg-black/40 rounded-lg text-white flex items-center justify-center'>
            {(uploadProgress * 100).toFixed(0)}%
          </span>
        )}

        {previewImage && (
          <i
            className='ic-outline md-delete !absolute -right-2 -top-2 bg-red-500 w-5 h-5 rounded-full text-white !flex items-center justify-center'
            onClick={showModal}
          />
        )}
      </article>
    );
  },
  isEqual
);

export default UploadArticle;
